import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const Summary = () => {
    const [summaryData, setSummaryData] = useState({
        volunteerCount: 0,
        aircraftCount: 0,
        judgedAircraftCount: 0,
        notJudgedAircraftCount: 0,
    });
    const [aircraftData, setAircraftData] = useState([]);
    const [volunteerData, setVolunteerData] = useState([]);

    const eventYear = new Date().getFullYear();
    
    const getVolunteers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/?includeArchived=false`, { withCredentials: true });
            setVolunteerData(response.data);
        } catch (error) {
            console.error('Error fetching volunteer data:', error);
        }
    };

    const getAircraft = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aircraft/`, { withCredentials: true });
            setAircraftData(response.data);
        } catch (error) {
            console.error('Error fetching aircraft data:', error);
        }
    };

    useEffect(() => {
        getVolunteers();
        getAircraft();
    }, []);

    useEffect(() => {
        console.log('Volunteer Data', volunteerData);
        console.log('Aircraft Data', aircraftData);
        const judgedAircraftCount = aircraftData.filter(a => a.Scores.length > 0).length;
        const notJudgedAircraftCount = aircraftData.filter(a => a.Scores.length === 0).length;

        setSummaryData(prevData => ({
            ...prevData,
            volunteerCount: volunteerData.length,
            aircraftCount: aircraftData.length,
            judgedAircraftCount: judgedAircraftCount,
            notJudgedAircraftCount: notJudgedAircraftCount,
        }));
    }, [volunteerData, aircraftData]);


    return (
        <>
            <h2 id='summary-header'>Summary {eventYear}</h2>
            <div id='summary-data'>
                <div className='count-container'>
                    <h4 className='count-header'>Volunteers</h4>
                    <div className='count-sub-container'>
                        <div className='count-data-container'>
                            <h5 className='count-sub-header'>Total</h5>
                            <p className='count-data'>{summaryData.volunteerCount}</p>
                        </div>
                    </div>
                </div>
                <div className='count-container'>
                    <h4>Aircraft</h4>
                    <div className='count-sub-container'>
                        <div className='count-data-container'>
                            <h5 className='count-sub-header'>Total</h5>
                            <p className='count-data'>{summaryData.aircraftCount}</p>
                        </div>
                        <div className='count-data-container'>
                            <h5 className='count-sub-header'>Judged</h5>
                            <p className='count-data'>{summaryData.judgedAircraftCount}</p>
                        </div>
                        <div className='count-data-container'>
                            <h5 className='count-sub-header'>To Go</h5>
                            <p className='count-data'>{summaryData.notJudgedAircraftCount}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Summary;